import { colorsSets } from "@similarweb/styles";
import type { Translate } from "app/filters/i18nFilter";

export enum DifficultyLevel {
    Difficult = "Difficult",
    Moderate = "Moderate",
    Easy = "Easy",
}

export const MAP_DIFFICULTY_LEVEL_TO_BACKGROUND_COLOR = {
    [DifficultyLevel.Difficult]: colorsSets.diverging["red 400"] as string,
    [DifficultyLevel.Moderate]: colorsSets.diverging["sky 200"] as string,
    [DifficultyLevel.Easy]: colorsSets.diverging["blue 400"] as string,
} as const;

export type DifficultyLevelLimits = {
    LOWEST: number;
    HIGHEST: number;
};

export const getDifficultyLevel = (
    difficultyGrade: number,
    difficultyLevelsWithLimits: Record<DifficultyLevel, DifficultyLevelLimits>,
) => {
    if (
        difficultyGrade >= difficultyLevelsWithLimits[DifficultyLevel.Easy].LOWEST &&
        difficultyGrade <= difficultyLevelsWithLimits[DifficultyLevel.Easy].HIGHEST
    ) {
        return DifficultyLevel.Easy;
    }
    if (
        difficultyGrade >= difficultyLevelsWithLimits[DifficultyLevel.Moderate].LOWEST &&
        difficultyGrade <= difficultyLevelsWithLimits[DifficultyLevel.Moderate].HIGHEST
    ) {
        return DifficultyLevel.Moderate;
    }
    if (
        difficultyGrade >= difficultyLevelsWithLimits[DifficultyLevel.Difficult].LOWEST &&
        difficultyGrade <= difficultyLevelsWithLimits[DifficultyLevel.Difficult].HIGHEST
    ) {
        return DifficultyLevel.Difficult;
    }
};

export const getDifficultyBarTexts = (translate: Translate, difficultyLevel: DifficultyLevel, country: string) => {
    return {
        labelText: translate(`keyword.difficulty.level.${difficultyLevel}.label`),
        easyLevelText: translate("keyword.difficulty.level.easy.label"),
        difficultLabelText: translate("keyword.difficulty.level.difficult.label"),
        disclaimerText: translate(`keyword.difficulty.level.${difficultyLevel}.disclaimer`, {
            country,
        }),
    };
};
